/* Ask only on account entry. Never grants marketing or cookie consent. */
(() => {
  'use strict';
  const dialog = document.getElementById('mc-privacy-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const accept = document.getElementById('mc-privacy-accept');
  const heading = document.getElementById('mc-privacy-title');
  const confirmation = document.getElementById('mc-privacy-confirmation');
  const checkbox = document.getElementById('mc-privacy-checkbox');
  if (!accept || !heading || !confirmation || !checkbox) return;
  const storageKey = 'mundo-cargolet:privacy:v12';
  const version = dialog.dataset.policyVersion;
  const ready = dialog.dataset.policyReady === 'true';
  const signedIn = dialog.dataset.signedIn === 'true';
  let pendingDestination = null;
  let previousFocus = null;
  let readingOnly = false;

  function remember(forLogin = false, acceptedAt = new Date().toISOString()) {
    if (!ready) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        version, signedIn, forLogin, acceptedAt
      }));
    } catch { /* Storage may be disabled; the button must still work. */ }
  }
  function forget() {
    try { sessionStorage.removeItem(storageKey); } catch { /* optional storage */ }
  }
  function absolute(value) {
    try { return value ? new URL(value, location.href) : null; }
    catch { return null; }
  }
  const policyUrl = absolute(dialog.dataset.policyUrl);
  const accountUrl = absolute(dialog.dataset.accountUrl);
  const loginUrl = absolute(dialog.dataset.loginUrl);

  function show(trigger = null, destination = null, readOnly = false) {
    previousFocus = trigger || document.activeElement;
    pendingDestination = destination;
    readingOnly = readOnly;
    confirmation.hidden = readOnly || !ready;
    checkbox.checked = false;
    accept.disabled = !readOnly && ready;
    accept.textContent = readOnly ? 'Cerrar' : ready ? 'Aceptar' : 'Continuar';
    // Only dismiss the homepage panel from which this action was requested.
    // Preserve game dialogs and every other existing flow.
    const detail = document.getElementById('detail-dialog');
    if (trigger && detail?.open && typeof detail.close === 'function') detail.close();
    document.documentElement.classList.add('mc-privacy-open');
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('.mc-privacy-scroll').scrollTop = 0;
    heading.focus({ preventScroll: true });
  }
  function finish() {
    if (!readingOnly && ready && !checkbox.checked) {
      checkbox.focus();
      return;
    }
    const destination = pendingDestination;
    if (!readingOnly) remember(Boolean(destination));
    pendingDestination = null;
    dialog.close();
    if (destination) {
      // The original href (including the manual return path) is preserved.
      if (destination.newTab) window.open(destination.href, '_blank', 'noopener');
      else location.assign(destination.href);
    }
  }
  checkbox.addEventListener('change', () => {
    accept.disabled = !readingOnly && ready && !checkbox.checked;
  });
  accept.addEventListener('click', finish);
  function dismiss() {
    pendingDestination = null;
    checkbox.checked = false;
    dialog.close();
  }
  document.getElementById('mc-privacy-close')?.addEventListener('click', dismiss);
  document.getElementById('mc-privacy-cancel')?.addEventListener('click', dismiss);
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('mc-privacy-open');
    if (previousFocus?.isConnected && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  });

  document.addEventListener('click', event => {
    const trigger = event.target instanceof Element ? event.target.closest('a,button') : null;
    if (!trigger || dialog.contains(trigger)) return;
    const url = absolute(trigger.getAttribute('href'));
    const isPolicy = trigger.matches('[data-dialog="privacidad"],[data-mc-privacy-open]') ||
      (url && policyUrl && url.origin === policyUrl.origin && url.pathname === policyUrl.pathname);
    if (isPolicy) {
      event.preventDefault(); event.stopImmediatePropagation();
      show(trigger, null, true);
      return;
    }
    if (url && url.origin === location.origin && /\/account\/logout\/?$/.test(url.pathname)) {
      forget();
      return;
    }
    if (signedIn) return;
    const accountButton = trigger.matches('[data-dialog="cuenta"]');
    const explicitLogin = trigger.matches('[data-mc-login]');
    const knownAccount = url && [accountUrl, loginUrl].some(candidate =>
      candidate && candidate.origin === url.origin && candidate.pathname === url.pathname);
    const localLogin = url && url.origin === location.origin &&
      /\/(?:customer_authentication\/login|account(?:\/(?:login|register))?)\/?$/.test(url.pathname);
    if (!accountButton && !explicitLogin && !knownAccount && !localLogin) return;
    const destination = url || absolute(window.MundoCargoletConfig?.accountUrl) || accountUrl;
    if (!destination || !/^https?:$/.test(destination.protocol)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    show(trigger, {
      href: destination.href,
      newTab: trigger.getAttribute('target') === '_blank' || event.metaKey || event.ctrlKey
    });
  }, true);

  // Browsing, reloads and history restoration never request acknowledgement.
  // Only the explicit account/login action above opens the acceptance flow.
})();
